// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dashboardPage: "Dashboard Page",
  driversRequests: "Driver Requests",
  search: "Search",
  pending: "Pending",
  approved: "Approved",
  accident: "Accident",
  vehicleBrokeDown: "Vehicle Broke Down",
  personalIssues: "Personal Issues",
  requestDetails: "Request Details",
  orderStatus: "Order Status",
  reason: "Reason",
  driverExplanation: "Driver Explanation",
  adminExplanation: "Rejection Explanation",
  oldDriverName: "Current Driver Name",
  newDriverName: "New Driver Name",
  newDriverLocation: "New Driver Location",
  streetName: "Street Name",
  files: "Files",
  profilePicture: "Personal Photo",
  identificationImageFront: "Copy of ID - Front Side",
  identificationImageBack: "Copy of ID - Back Side",
  driverLicence: "Driver License",
  vehicleLicense: "Vehicle License",
  nonCriminalRecord: "Non-Criminal Record Certificate",
  tradeLicense: "Trade License",
  registrationCertificate: "Commercial Registration Certificate",
  iconImage: "Icon Image",
  logoImage: "Logo Image",
  vatNumber: "Vat Number",
  driverChangeRequestAttachment: "Driver Change Request Attachment",
  approve: "Approve",
  decline: "Decline",
  declineExplanation: "Decline Explanation",
  requestApproveSuccess: "Driver Request Approved Successfully",
  requestDeclineSuccess: "Driver Request Declined Successfully",
  requestFail:
    "Driver Request Approval/Decline failed to process, please try again",
  download: "Download",
  rejectionExplanation: "Rejection Explanation",
  ORDERS: "Orders",
  DRIVERS_REQUESTS: "Drivers Requests",
  DASHBOARD: "Dashboard",
  orderDetails: "Order Details",
  driverDetails: "Driver Details",
  businessDetails: "Business Details",
  receiverDetails: "Receiver Details",
  logs: "Logs",
  placedOn: "Placed On",
  updated: "Updated",
  pickupDateTime: "Pickup Date Time",
  deliveryDateTime: "Delivery Date Time",
  size: "Size",
  quantity: "Quantity",
  weight: "Weight",
  orderFees: "Order Fees",
  orderAmount: "Order Amount",
  fanoosFees: "Fanoos Fees",
  driverFees: "Driver Fees",
  deliveryFees: "Delivery Fees",
  notes: "Notes",
  contactPhoneNumber: "Contact Phone Number",
  isExpedited: "Is Expedited",
  isPaid: "Is Paid",
  qrCodeId: "QR Code Id",
  pickUpLocation: "Pickup Location",
  locationTitle: "Location Title",
  city: "City",
  area: "Area",
  street: "Street",
  buildingNumber: "Building Number",
  officeNumber: "Office Number",
  floorNumber: "Floor Number",
  coordinates: "Coordinates",
  latitude: "Lat",
  longitude: "Lon",
  dropOffLocation: "Drop Off Location",
  addressName: "Address Name",
  description: "Description",
  prefeeredPickUpDate: "Preferred Pickup Date",
  prefeeredDeliveryDate: "Preferred Delivery Date",
  senderId: "Sender Id",
  reciverId: "Receiver Id",
  driverId: "Driver Id",
  driverName: "Driver Name",
  category: "Category",
  preferedVehicleType: "Preferred Vehicle Type",
  modificationDate: "Modification Date",
  userType: "User Type",
  note: "Note",
  receiver: "Receiver",
  driver: "Driver",
  sender: "Sender",
  admin: "Admin",
  orderNumber: "Order #",
  shipmentInfo: "Shipment Info",
  fees: "Fees",
  businessInfo: "Business Information",
  fullName: "Business Name",
  phoneNumber: "Business Phone Number",
  busnissType: "Business Type",
  email: "Business Email",
  nationalNumber: "Business National Number",
  website: "Website URL",
  address: " Business Address",
  openHours: "Open Hours",
  personalInfo: "Personal Info",
  professionalInfo: "Professional Info",
  birthday: "Birthday",
  education: "Education",
  gender: "Gender",
  englishSpeaker: "English Speaker",
  orderCount: "Order Count",
  orderLimit: "Order Limit",
  isOnline: "Is Online",
  collectedOrderCash: "Collected Order Cash",
  toBeCollectedOrderCash: "To Be Collected Order Cash",
  myEarnings: "My Earnings",
  expectedEarnings: "Expected Earnings",
  secondaryPhoneNumber: "Secondary Phone Number",
  noDriverAssigned: "No Driver Assigned Yet",
  locationLink: "Location Link",
  regular: "Regular",
  expedited: "Expedited",
  paid: "Paid",
  notPaid: "Not Paid",
  cancel: "Cancel",
  orderCancellationSuccess: "Order cancelled successfully",
  orderCancellationFail: "Failed to cancel order, please try again",
  viewLocation: "View Location",
  ordersPage: "Orders Page",
  ordersList: "Orders List",
  orderInfo: "Order Information",
  status: "Status",
  senderName: "Sender Name",
  reciverName: "Receiver Name",
  creationDate: "Creation Date",
  action: "Action",
  view: "View",
  draft: "Draft",
  incompleteData: "Incomplete Data",
  awaitingSelection: "Awaiting Selection",
  pendingPickup: "Pending Pickup",
  pickUpStarted: "Pickup Started",
  arrivedAtPickup: "Arrived At Pickup",
  orderCollected: "Collected",
  orderOutForDelivery: "Out For Delivery",
  arrivedAtDropOff: "Arrived At Drop-off",
  delivered: "Delivered",
  cancelled: "Cancelled",
  rejected: "Rejected",
  onHold: "On Hold",
  rescheduled: "Rescheduled",
  returned: "Returned",
  failed: "Failed",
  requestDriverChange: "Request Driver Change",
  driverChangeApproved: "Driver Change Approved",
  driverChangeRejected: "Driver Change Rejected",
  details: "Details",
  id: "Id",
  orderType: "Order Type",
  all: "All",
  date: "Date",
  ordersSearch: "Search by Name",
  clearFilters: "Clear Filters",
  noDataFound: "No Data Found",
  from: "From",
  to: "To",
  invalidDateRange: "Invalid Date Range",
  Large: "Large",
  welcomeback: "Welcome Back",
  ordersStatistics: "Orders Statistics",
  totalOrders: "Total Orders",
  activeOrders: "Active Orders",
  completedOrders: "Completed Orders",
  incompleteOrders: " Incomplete Orders ",
  activeDrivers: "Active Drivers",
  rejectedOrders: "Rejected Orders",
  rescheduledOrders: "Rescheduled Orders",
  canceledOrders: "Canceled Orders",
  unAssignedOrders: "Un-assigned Orders",
  needsAttention: "Needs Attention",
  driverChange: "Driver Change",
  deliveryFailure: "Delivery Failure",
  reject: "Reject",
  markAsResolved: "Mark As Resolved",
  cycleTime: "Cycle Time",
  scheduledTime: "Scheduled Time",
  actualTime: "Actual Time",
  driverContactInformation: "Driver Contact Information",
  name: "Name",
  location: "Location",
  businessType: "Business Type",
  apartmentNumber: "Apartment Number",
  receiverName: "Receiver Name",
  of: "Of",
  jan: "Jan",
  feb: "Feb",
  mar: "Mar",
  jun: "Jun",
  jul: "Jul",
  aug: "Aug",
  sep: "Sep",
  oct: "Oct",
  nov: "Nov",
  dec: "Dec",
  apr: "Apr",
  may: "May",
  pendingOrder: "Pending Order",
  delayedDelivery: "Delayed Delivery",
  delayedPickup: "Delayed Pickup",
  pendingRescheduledOrder: "Pending Rescheduled",
  driverChangeRequest: "Driver Change Request",
  rejectedOrder: "Rejected Order",
  canceledOrder: "Canceled Order",
  deliveryFailureOrder: "Delivery Failure Order",
  confirmResolution: "Confirm Resolution",
  areYouSureYouWantToResolveThisIssue:
    "Are You Sure You Want To Resolve This Issue?",
  driverPhoneNumber: "Driver Mobile Number",
  senderPhoneNumber: "Sender Phone Number",
  receiverPhoneNumber: "Receiver Phone Number",
  contactInformation: "Contact Information",
  issueResolvedSuccessfully: "Issue Resolved Successfully",
  errorResolvingIssue: "Error Resolving Issue",
  noDataAvailable: "No Data Available",
  orders: "Orders",
  hour: "Hour",
  hours: "Hours",
  minute: "minute",
  minutes: "minutes",
  ago: "ago",
  dropOffDateTime: "Drop-off Date Time",
  notAvaliabel: "Not Avaliabel",
  noDriverAssignedYet: "No Driver Assigned Yet",
  areYouSureYouWantToLogout: "Are You Sure You Want To Logout",
  confirmLogout: "Confirm Logout",
  logout: "Logout",
  customerManagement: "Customer Management",
  registrationStatus: "Registration Status",
  registered: "Registered",
  pendingForApproval: "Pending For Approval",
  active: "Active",
  inReview: "In Review",
  areYouSureYouWantToApprove: "Are you sure you want to approve?",
  confirmAction: "Confirm Action",
  senderOrders: "Sender Orders",
  senderInfo: "Sender Info",
  customerDetails: "Customer Details",
  personalInformation: "Personal Information",
  dispatchOrder: "Dispatch Order",
  availableDrivers: "Available Drivers",
  nodriversavailableatthemoment: "No drivers available at the moment",
  noActiveDriversAtTheMoment: "No Active Drivers at the moment",
  assignOrder: "Assign order",
  goBack: "Go Back",
  phone: "Phone",
  distance: "Distance",
  nextSteppickupstarted: "Next Step : Pick-up started",
  nextStepArrivedAtPickup: "Next Step: Arrived At Pickup",
  nextStepCollected: "Next Step: Collected",
  nextStepOutForDelivery: "Next Step: Out For Delivery",
  nextStepArrivedAtDropoff: "Next Step: Arrived At Drop-off",
  nextStepDelivered: "Next Step: Delivered",

  pickuptripstartedsuccessfully: "Pickup trip started successfully!",
  actionnotallowedThedrivercurrentlyhasanotheractiveorder:
    "Action not allowed: The driver currently has another active order.",
  successfullyarrivedatpickup: "Successfully arrived at pickup!",
  failedtocollectorder: "Failed to collect order.",
  ordercollectedsuccessfully: "Order collected successfully!",
  failedtostartdelivery: "Failed to start delivery.",
  orderisoutfordelivery: "Order is out for delivery!",
  successfullyarrivedatdropoff: "Successfully arrived at drop-off!",
  failedtoarriveatdropoff: "Failed to arrive at drop-off.",
  orderdeliveredsuccessfully: "Order delivered successfully!",
  failedtodeliverorder: "Failed to deliver order.",
  canceledOrderIssues: "Canceled Order",
  rejectedOrderIssues: "Rejected Order",
  pushNotifiaction: "Notification Management ",
  PushNotificationManagement: "Push Notification Management",
  // TargetAudience:"Target Audience",
  // AllDrivers:"All Drivers",
  // ApprovedDrivers:"Approved Drivers",
  NotificationTitleLabel: "Notification Title",
  NotificationBodyLabel: "Notification Body",
  NotificationContent: "Enter the content here",
  // SaveAsDraft	:"Save as Draft",
  Publish: "Publish",
  notificationDialogBody:
    "Your push notification has been successfully sent to the selected audience.",
  notificationSuccses: "Notification Successfully Published!",
  requiredField: "This field is required !",
  refresh: "Refresh",
  driverManagement: "Driver Management",
  driverphoneNumber: " Phone Number",
  age: "Age",
  driverInfo: "Driver Info",
  driverOrders: "Driver Orders",
  driverfullName: "Full Name",
  drivernationalNumber: "Driver National Number",
  cityArea: "City Area",
  vehicleType: "Vehicle Type",
  noDocumentsAvailable: "No Documents Available",
  sortAZ: "Sort A-Z",
  sortZA: "Sort Z-A",
  sortAscending: "Sort Ascending",
  sortDescending: "Sort Descending",
  contactsInformation: "Contacts Details",
  contactDetails: "Contact Details",
  contactName: "Contact Person Name",
  contactPersonMopileNumber: "Contact Person Mobile Number",
  occupation: "Occupation",
  loading: "Loading . . . ",
  no: "No",
  yes: "Yes",
  isActive: "Is Active",
  inactive: " Inactive",
  preparatory: "Preparatory",
  secondary: "Secondary",
  bachelor: "Bachelor",
  female: "Female",
  male: "Male",
  retailers: "Retailers",
  manufacturers: "Manufacturers",
  wholesalersDistributors: "Wholesalers Distributors",
  eCommercePlatforms: "E-Commerce Platforms",
  healthcarePharmaceutical: "Healthcare Pharmaceutical",
  logisticsTransportation: "Logistics Transportation",
  serviceBased: "Service Based",
  enterResolutionReason: "Enter Resolution Reason...",
  issueType: "Issue Type",
  dateAndTime: "Date & Time",
  adminSolution: "Admin Solution",
  issuesAndSolutions: "Issues & Solutions",
  resolutionNoteRequired: "Resolution note is required",
  receiverWhatsappNumber: "Receiver WhatsApp",
  searchDriverByName: "Search Driver By Name",
  searchCustomersByName: "Search Customers By Name",
  myRouteOrders: "My Route Orders",
  submit: "Submit",
  driverphoneNumberholder: "Driver Phone Number",
  backToOrdersList: "Back to Orders List",
  backToCustomerManagement: "Back To Customer Management",
  backToDriverRequests: "Back To Driver Requests",
  backToDriverManagement: "Back To Driver Management",
  conversationFailed: "Conversation Failed",
  activeAddress: "Address",
  activeTime: "Active Time",
  ActivephoneNumber: "Phone Number",
  exportAs: " Export As",
  lastUpdate: "Last Update",
  viewDriverLocation: "View driver's location",
  back: "Back",
  searchByOrderId: "Search by order ID",
  reasonForOrderUpdate: "Reason for order update: ",
  pleaseSelectReason: "Please select a reason for order rejection.",
  damagedShipment: "Damaged shipment",
  paymentIssues: "Payment issues",
  receiverRefused: "Receiver refused to accept order",
  other: "Other:",
  typeReason: "Type Reason",
  save: "Save",
  orderRejectedSuccessfully: "Order rejected successfully!",
  failedToRejectOrder: "Failed to reject order.",
  noDriverAssignedToOrder: "No driver is assigned to this order.",
  failedToFetchOrderDetails: "Failed to fetch order details.",
  pleaseSelectFailureReason: "Please select a reason for failure.",
  receiverUnavailable: "Receiver is unavailable",
  receiverUnresponsive: "Receiver is unresponsive",
  incorrectAddress: "Incorrect address",
  deliveryFailureSuccess: "Delivery failure reported successfully!",
  deliveryFailureError: "Failed to report delivery failure.",
  delayOrder: "Delay Order",
  chooseDateTimeSlot: "Please choose preferred date & time slot.",
  today: "Today",
  tomorrow: "Tomorrow",
  time: "Time",
  orderDelayedSuccessfully: "Order has been successfully rescheduled!",
  failedToDelayOrder: "Failed to reschedule the order.",
  delay: "Delay",
  driverChangePrompt:
    "You are requesting to assign the order to another driver. Please select a reason.",
  explainReason: "Explain reason",
  attachmentForRequest: "Attachment for request",
  uploadDocuments: "Upload Documents",
  driverChangeRequestSuccess: "Driver change request submitted successfully!",
  driverChangeRequestError:
    "Please upload the required attachment before submitting your request.",
  rescheduleOrder: "Reschedule Order",
  driverRequestInformation: "Driver Request Information",
  zeroFees: "Zero Fees",
  acceptZeroFees: "Accept Zero Fees",
  setZeroFeesDuration: "Set Zero Fees Duration",
  zeroStartDate: "Start Date",
  zeroEndDate: "End Date",
  zeroFeesUpdateSuccess: "Zero fees status updated successfully",
  zeroFeesUpdateError: "Failed to update zero fees status",
};
